import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { TitanApiQueryEntity } from './titan-api-query.entity';
import { TriggerGroupCategoryEntity } from './trigger-group-category.entity';
import { TriggerGroupStateHistoryEntity } from './trigger-group-state-history.entity';

@Index('_trigger_group__fk__titan_api_query__id_fk', ['fkTitanApiQueryId'], {})
@Index(
	'_trigger_group__fk__trigger_group_category__id_fk',
	['fkTriggerGroupCategoryId'],
	{},
)
@Entity('_trigger_group')
export class TriggerGroupEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('int', { name: '_fk__object__id', nullable: true, unsigned: true })
	public fkObjectId!: number | null;

	@Column('tinyint', { name: '_holdState', width: 1, default: () => "'0'" })
	public holdState!: boolean;

	@Column('int', {
		name: '_fk__titan_api_query__id',
		nullable: true,
		unsigned: true,
	})
	public fkTitanApiQueryId!: number | null;

	@Column('longtext', { name: '_diagram' })
	public diagram!: string;

	@Column('varchar', { name: '_manipulation', length: 255 })
	public manipulation!: string;

	@Column('longtext', { name: '_description' })
	public description!: string;

	@Column('tinyint', { name: '_active', width: 1 })
	public active!: boolean;

	@Column('int', { name: '_maxIterationsPerBaseObject', nullable: true })
	public maxIterationsPerBaseObject!: number | null;

	@Column('int', { name: '_version', default: () => "'0'" })
	public version!: number;

	@Column('int', { name: '_priority', default: () => "'0'" })
	public priority!: number;

	@Column('int', {
		name: '_fk__trigger_group_category__id',
		nullable: true,
		unsigned: true,
	})
	public fkTriggerGroupCategoryId!: number | null;

	@Column('int', { name: '_maxIterationDurationInDays', default: () => "'0'" })
	public maxIterationDurationInDays!: number;

	@Column('tinyint', {
		name: '_allowConcurrentExecution',
		width: 1,
		default: () => "'0'",
	})
	public allowConcurrentExecution!: boolean;

	@ManyToOne(
		() => TitanApiQueryEntity,
		(titanApiQuery) => titanApiQuery.triggerGroups,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__titan_api_query__id', referencedColumnName: 'id' },
	])
	public fkTitanApiQuery!: TitanApiQueryEntity;

	@ManyToOne(
		() => TriggerGroupCategoryEntity,
		(triggerGroupCategory) => triggerGroupCategory.triggerGroups,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__trigger_group_category__id', referencedColumnName: 'id' },
	])
	public fkTriggerGroupCategory!: TriggerGroupCategoryEntity;

	@OneToMany(
		() => TriggerGroupStateHistoryEntity,
		(triggerGroupStateHistory) => triggerGroupStateHistory.fkTriggerGroup,
		{},
	)
	public triggerGroupStateHistories!: Array<TriggerGroupStateHistoryEntity>;
}
